import * as React from 'react';
import styled from 'react-emotion';
import { Dialogs } from './DialogsEnum';

interface DialogPaddingProps {
  openDialog: Dialogs;
}

const Padding = styled('div')`
  padding-right: ${(props: DialogPaddingProps) => {
    return props.openDialog ? '15' : '0';
  }}px;
`;

interface DialogPaddingState {
  openDialog: Dialogs;
}

function timeout(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

class DialogPadding extends React.Component<
  DialogPaddingProps,
  DialogPaddingState
> {
  state = {
    openDialog: Dialogs.None,
  };

  componentDidUpdate(prevProps: DialogPaddingProps) {
    const { openDialog } = this.props;
    if (openDialog !== prevProps.openDialog) {
      // Dialog opens
      if (openDialog) {
        // eslint-disable-next-line
        this.setState({ openDialog });
        return;
      }
      // Dialog closes
      return timeout(200).then(() => {
        this.setState({ openDialog });
      });
    }
    return undefined;
  }

  render() {
    const { openDialog } = this.state;
    const { children } = this.props;
    return <Padding openDialog={openDialog}>{children}</Padding>;
  }
}

export default DialogPadding;
